<template>
  <div class="product-detail">
    <div class="container">
      <!-- 返回按钮 -->
      <div class="product-detail__back">
        <button class="btn-back" @click="goBack">
          <span class="btn-back__icon">←</span>
          <span class="btn-back__text">返回产品列表</span>
        </button>
      </div>
      
      <!-- 产品详情 -->
      <div v-if="product" class="product-detail__content">
        <!-- 产品图片 -->
        <div class="product-detail__image">
          <img :src="product.image" :alt="product.name">
        </div>
        
        <!-- 产品信息 -->
        <div class="product-detail__info">
          <h2 class="product-detail__name">{{ product.name }}</h2>
          <p class="product-detail__description">{{ product.description }}</p>
          <div class="product-detail__details">
            <h3 class="product-detail__details-title">产品详情</h3>
            <p class="product-detail__details-content">{{ product.details }}</p>
          </div>
          
          <!-- 技术参数 -->
          <div class="product-detail__parameters">
            <h3 class="product-detail__parameters-title">技术参数</h3>
            <div class="product-detail__parameters-list">
              <div 
                v-for="(param, index) in product.parameters" 
                :key="index"
                class="product-detail__parameter-item"
              >
                <span class="product-detail__parameter-name">{{ param.name }}</span>
                <span class="product-detail__parameter-value">{{ param.value }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <!-- 加载状态 -->
      <div v-else-if="loading" class="product-detail__loading">
        加载中...
      </div>
      
      <!-- 无数据状态 -->
      <div v-else class="product-detail__empty">
        产品不存在
      </div>
    </div>
  </div>
</template>

<script>
import { productsApi } from '@/api/modules/products'

export default {
  name: 'ProductDetail',
  data() {
    return {
      product: null,
      loading: false
    }
  },
  mounted() {
    this.getProductDetail()
  },
  methods: {
    async getProductDetail() {
      this.loading = true
      try {
        const id = localStorage.getItem('productId')
        const response = await productsApi.getProductDetail(id)
        if (response.code === 200) {
          this.product = response.data
        }
      } catch (error) {
        console.error('获取产品详情失败:', error)
      } finally {
        this.loading = false
      }
    },
    goBack() {
      // 切换回产品列表页面
      window.dispatchEvent(new CustomEvent('switchPage', {
        detail: { page: 'products' }
      }))
    }
  }
}
</script>

<style scoped>
.product-detail {
  padding: 60px 0;
  background-color: #f5f5f5;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.product-detail__back {
  margin-bottom: 30px;
}

.btn-back {
  display: flex;
  align-items: center;
  background-color: #ffffff;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  padding: 10px 16px;
  font-size: 14px;
  color: #333;
  cursor: pointer;
  transition: all 0.3s;
}

.btn-back:hover {
  background-color: #f0f0f0;
  border-color: #007bff;
  color: #007bff;
}

.btn-back__icon {
  margin-right: 8px;
  font-size: 16px;
}

.product-detail__content {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 40px;
  background-color: #ffffff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  padding: 40px;
}

.product-detail__image {
  width: 100%;
  height: 400px;
  overflow: hidden;
  border-radius: 8px;
}

.product-detail__image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.product-detail__info {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.product-detail__name {
  font-size: 28px;
  font-weight: 700;
  color: #333;
  margin: 0;
}

.product-detail__description {
  font-size: 16px;
  color: #666;
  line-height: 1.5;
  margin: 0;
}

.product-detail__details {
  margin-top: 10px;
}

.product-detail__details-title {
  font-size: 20px;
  font-weight: 600;
  color: #333;
  margin-bottom: 15px;
}

.product-detail__details-content {
  font-size: 14px;
  color: #666;
  line-height: 1.6;
  margin: 0;
}

.product-detail__parameters {
  margin-top: 20px;
}

.product-detail__parameters-title {
  font-size: 20px;
  font-weight: 600;
  color: #333;
  margin-bottom: 15px;
}

.product-detail__parameters-list {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
}

.product-detail__parameter-item {
  display: flex;
  justify-content: space-between;
  padding: 10px 15px;
  background-color: #f9f9f9;
  border-radius: 4px;
  font-size: 14px;
}

.product-detail__parameter-name {
  color: #333;
  font-weight: 500;
}

.product-detail__parameter-value {
  color: #666;
}

.product-detail__loading {
  text-align: center;
  padding: 100px 0;
  color: #666;
  font-size: 16px;
  background-color: #ffffff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.product-detail__empty {
  text-align: center;
  padding: 100px 0;
  color: #666;
  font-size: 16px;
  background-color: #ffffff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

@media (max-width: 767px) {
  .product-detail {
    padding: 40px 0;
  }
  
  .product-detail__content {
    grid-template-columns: 1fr;
    padding: 20px;
    gap: 20px;
  }
  
  .product-detail__image {
    height: 250px;
  }
  
  .product-detail__name {
    font-size: 24px;
  }
  
  .product-detail__description {
    font-size: 14px;
  }
  
  .product-detail__details-title {
    font-size: 18px;
  }
  
  .product-detail__parameters-title {
    font-size: 18px;
  }
  
  .product-detail__parameters-list {
    grid-template-columns: 1fr;
  }
  
  .btn-back {
    padding: 8px 12px;
    font-size: 13px;
  }
}

@media (min-width: 768px) and (max-width: 991px) {
  .product-detail__content {
    grid-template-columns: 1fr;
    gap: 30px;
  }
  
  .product-detail__image {
    height: 300px;
  }
}
</style>